import angular from 'angular';
import { MoveOfferCardComponent } from './move-offer-card.component';
import { CardModule } from '../../../core';
import { UCloudinaryImageDirectives } from '../../../common/directives';

export const MoveOfferCardModule = angular
  .module('app.steps.move-offer-card', [
    CardModule.name,
    UCloudinaryImageDirectives.name,
  ])
  .component('updMoveOfferCard', MoveOfferCardComponent);
